
      var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgMainClc = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 60,
  height: 60,
  viewBox: "0 0 81 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M70 18.625c-.217.505-.319.997-.597 1.338-.634.778-1.29 1.563-2.051 2.202-2.206 1.848-4.474 3.62-6.708 5.434-1.813 1.471-3.644 2.929-5.192 4.704a20.278 20.278 0 0 0-1.671 2.218c-.577.882-.594 1.816-.181 2.825.968 2.368 2.164 4.613 3.386 6.845 3.379 6.17 6.649 12.4 9.66 18.768.558 1.181.939 2.45 1.397 3.682.047.127.073.266.084.402.055.673-.246 1.06-.886.933-.7-.14-1.42-.36-2.035-.72a86 86 0 0 1-4.457-2.824c-4.725-3.166-9.434-6.358-14.154-9.532-1.912-1.286-3.88-2.472-6-3.372-1.61-.684-3.272-1.06-5.03-.904-1.334.118-2.566.562-3.76 1.15-2.143 1.058-4.072 2.466-5.965 3.92-3.787 2.908-7.543 5.858-11.325 8.774-.815.628-1.677 1.195-2.533 1.765a5.13 5.13 0 0 1-1.077.554c-.583.212-.98-.1-.893-.726a6.87 6.87 0 0 1 .41-1.502c.998-2.583 1.983-5.172 3.041-7.729 1.698-4.103 3.465-8.176 5.17-12.275.61-1.467 1.132-2.967 1.45-4.541.37-1.829-.13-3.276-1.652-4.297-.852-.572-1.76-1.058-2.649-1.57-.632-.364-1.281-.698-1.911-1.066-.35-.204-.69-.43-1.01-.681-1.013-.799-.957-1.763.202-2.301a47.954 47.954 0 0 1 4.038-1.644c2.103-.752 4.236-1.42 6.347-2.15.787-.273 1.55-.62 2.323-.934 1.991-.813 3.563-2.178 4.71-3.998 1.134-1.803 2.127-3.698 3.21-5.536.512-.87 1.033-1.746 1.655-2.534.355-.45.878-.82 1.398-1.064.985-.463 1.691-.254 2.344.629.42.568.77 1.193 1.13 1.806.665 1.131 1.294 2.286 1.976 3.406.612 1.006 1.518 1.649 2.652 1.862.736.139 1.506.254 2.241.18a160.6 160.6 0 0 0 7.038-.867c3.67-.533 7.326-1.153 10.996-1.67 1.005-.141 2.042-.084 3.061-.048.415.015.853.156 1.222.355.247.133.39.468.596.733z",
  fill: "var(--theme-primary, #810ea9)"
})));

      const __svgRaw = "<svg width=\"60\" height=\"60\" viewBox=\"0 0 81 80\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M70 18.625c-.217.505-.319.997-.597 1.338-.634.778-1.29 1.563-2.051 2.202-2.206 1.848-4.474 3.62-6.708 5.434-1.813 1.471-3.644 2.929-5.192 4.704a20.278 20.278 0 0 0-1.671 2.218c-.577.882-.594 1.816-.181 2.825.968 2.368 2.164 4.613 3.386 6.845 3.379 6.17 6.649 12.4 9.66 18.768.558 1.181.939 2.45 1.397 3.682.047.127.073.266.084.402.055.673-.246 1.06-.886.933-.7-.14-1.42-.36-2.035-.72a86 86 0 0 1-4.457-2.824c-4.725-3.166-9.434-6.358-14.154-9.532-1.912-1.286-3.88-2.472-6-3.372-1.61-.684-3.272-1.06-5.03-.904-1.334.118-2.566.562-3.76 1.15-2.143 1.058-4.072 2.466-5.965 3.92-3.787 2.908-7.543 5.858-11.325 8.774-.815.628-1.677 1.195-2.533 1.765a5.13 5.13 0 0 1-1.077.554c-.583.212-.98-.1-.893-.726a6.87 6.87 0 0 1 .41-1.502c.998-2.583 1.983-5.172 3.041-7.729 1.698-4.103 3.465-8.176 5.17-12.275.61-1.467 1.132-2.967 1.45-4.541.37-1.829-.13-3.276-1.652-4.297-.852-.572-1.76-1.058-2.649-1.57-.632-.364-1.281-.698-1.911-1.066-.35-.204-.69-.43-1.01-.681-1.013-.799-.957-1.763.202-2.301a47.954 47.954 0 0 1 4.038-1.644c2.103-.752 4.236-1.42 6.347-2.15.787-.273 1.55-.62 2.323-.934 1.991-.813 3.563-2.178 4.71-3.998 1.134-1.803 2.127-3.698 3.21-5.536.512-.87 1.033-1.746 1.655-2.534.355-.45.878-.82 1.398-1.064.985-.463 1.691-.254 2.344.629.42.568.77 1.193 1.13 1.806.665 1.131 1.294 2.286 1.976 3.406.612 1.006 1.518 1.649 2.652 1.862.736.139 1.506.254 2.241.18a160.6 160.6 0 0 0 7.038-.867c3.67-.533 7.326-1.153 10.996-1.67 1.005-.141 2.042-.084 3.061-.048.415.015.853.156 1.222.355.247.133.39.468.596.733z\" fill=\"var(--theme-primary, #810ea9)\"/>\r\n\r\n</svg>";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/main-clc.3019dcfabaf5f32425c9810cbc28f576.svg"),
        {
          React: SvgMainClc,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      